module.exports = __webpack_public_path__ + "img/wechat.adf7f4f7.jpg";